import { useLang } from "../../context/LangContext";
import { ERRORS } from "../../lib/i18n";

export const validateForm = (f) => {
  const e = {};
  if (f.name.trim().length < 2) e.name = "invalid_name";
  if (!/^(?:\+?966|0)?5\d{8}$/.test(f.phone.replace(/[\s-]/g, ""))) e.phone = "invalid_phone";
  if (f.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.trim())) e.email = "invalid_email";
  if (!f.city.trim()) e.city = "invalid_address";
  if (f.district.trim().length < 2) e.district = "invalid_address";
  if (f.street.trim().length < 2) e.street = "invalid_address";
  if (f.postal_code && !/^\d{5}$/.test(f.postal_code.trim())) e.postal_code = "invalid_postal_code";
  if (f.short_address && !/^[A-Za-z]{4}\d{4}$/.test(f.short_address.trim())) e.short_address = "invalid_short_address";
  return e;
};

const Field = ({ k, label, form, setForm, errors, span = 1, dir, list, type = "text", inputMode }) => {
  const { lang } = useLang();
  return (
    <label className={span === 2 ? "sm:col-span-2" : ""}>
      <span className="text-xs tracking-[0.08em] text-sand-dark">{label}</span>
      <input data-testid={`checkout-${k}-input`} type={type} inputMode={inputMode} dir={dir} list={list} value={form[k]}
        onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} className={`field ${errors[k] ? "border-destructive" : ""}`} />
      {errors[k] && <span data-testid={`checkout-${k}-error`} className="mt-1 block text-xs text-destructive">{ERRORS[errors[k]]?.[lang]}</span>}
    </label>
  );
};

export const CheckoutForm = ({ form, setForm, errors, cities }) => {
  const { t } = useLang();
  const p = { form, setForm, errors };
  return (
    <div className="space-y-12">
      <section>
        <h2 className="mb-6 font-display text-2xl">{t("step_info")}</h2>
        <div className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
          <Field k="name" label={t("name")} span={2} {...p} />
          <Field k="phone" label={t("phone")} dir="ltr" inputMode="tel" type="tel" {...p} />
          <Field k="email" label={t("email_opt")} dir="ltr" type="email" {...p} />
        </div>
      </section>
      <section>
        <h2 className="mb-6 font-display text-2xl">{t("delivery_address")}</h2>
        <div className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
          <Field k="city" label={t("city")} list="ksa-cities" {...p} />
          <datalist id="ksa-cities">{cities.map((c) => <option key={c} value={c} />)}</datalist>
          <Field k="district" label={t("district")} {...p} />
          <Field k="street" label={t("street")} span={2} {...p} />
          <Field k="building_no" label={t("building_no")} inputMode="numeric" {...p} />
          <Field k="additional_no" label={t("additional_no")} inputMode="numeric" {...p} />
          <Field k="postal_code" label={t("postal_code")} inputMode="numeric" dir="ltr" {...p} />
          <Field k="short_address" label={t("short_address")} dir="ltr" {...p} />
          <Field k="notes" label={t("notes")} span={2} {...p} />
        </div>
      </section>
    </div>
  );
};
